import { render } from "./ClaimMediaGalleryViewer.vue?vue&type=template&id=2c2f84ce&bindings={}"
import script from "./ClaimMediaGalleryViewer.vue?vue&type=script&lang=ts"
export * from "./ClaimMediaGalleryViewer.vue?vue&type=script&lang=ts"

import "./ClaimMediaGalleryViewer.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script